import styled, { css } from "styled-components";

export const ContactContainerOuter = styled.div`
  margin-top: 0.1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const ContactContainerInfo = styled.section`
  display: flex;
  flex-direction: column;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 0.375rem;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const OuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 20% 60% 20%;
  font-weight: bold;
  margin-bottom: 15px;
`;

export const ContactInfoOuter = styled.div`
  display: block;
`;

export const ContactInfo = styled.div`
  justify-self: auto;
  color: ${(props) => props?.color ?? "#767676"};
  font-size: ${(props) => props?.fontSize ?? "14px"};
  font-weight: bold !important;
  padding-left: 4px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;
